import "./Evento.css";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import Grid from "@mui/material/Grid";
import Box from "@mui/joy/Box";
import { urlRoot } from "../global";

function EventoDatos({ Evento, Registrado, InfoCampus }) {
  var ruta = window.location.origin;
  var palabra = "localhost";
  var index = ruta.indexOf(palabra);
  if (index < 0) ruta = ruta + "/" + urlRoot;

  return (
    <Box
      className="eventoDatosSection"
      style={{ background: "#f8f8f8" }}
      sx={{ flexGrow: 1, paddingLeft: "8%", paddingRight: "8%" }}
    >
      <Grid container spacing={4} alignItems="flex-start">
        {Evento.map((eventos) => (
          <>
            {InfoCampus.map((informacionC) => {
              const telefono =
                eventos?.event?.telefono || informacionC?.admissions_number;
              const correo =
                eventos?.event?.correo || informacionC?.admissions_email;
              const tieneContacto = telefono || correo;
              const esPresencialOHibrido =
                eventos.event.experience === "presencial" ||
                eventos.event.experience === "hibrido";
              const tieneUbicacion =
                esPresencialOHibrido && eventos.event.ubicacion;

              if (!tieneContacto && !tieneUbicacion) return null;

              return (
                <>
                  {tieneContacto && (
                    <Grid item md={4} lg={4} xs={12}>
                      <div className="contact_information">
                        <h2 className="tituloInfo">Datos de contacto</h2>

                        {telefono && (
                          <div className="info-container">
                            <PhoneIcon />
                            <Box
                              sx={{
                                display: { xs: "none", md: "block" },
                                width: "100%",
                              }}
                            >
                              <p className="gerytext">{telefono}</p>
                            </Box>
                            <Box
                              sx={{
                                display: { xs: "block", md: "none" },
                                width: "100%",
                              }}
                            >
                              <p className="gerytext">
                                <a
                                  style={{ textDecoration: "none", color: "inherit" }}
                                  href={`tel:${telefono.replace(/\s+/g, "")}`}
                                >
                                  {telefono}
                                </a>
                              </p>
                            </Box>
                          </div>
                        )}

                        {correo && (
                          <div className="info-container">
                            <EmailIcon />
                            <p className="gerytext" style={{ cursor: "pointer" }}>
                              <a
                                className="gerytext"
                                href={`mailto:${correo}`}
                                style={{ textDecoration: "none", color: "inherit" }}
                              >
                                {correo}
                              </a>
                            </p>
                          </div>
                        )}
                      </div>
                    </Grid>
                  )}

                  {tieneUbicacion && (
                    <Grid item md={4} lg={4} xs={12}>
                      <h2 className="tituloInfo">Ubicación</h2>
                      <p className="ubicacionTexto">{eventos.event.ubicacion}</p>
                    </Grid>
                  )}

                  {tieneUbicacion && (
                    <Grid
                      item
                      md={4}
                      lg={4}
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: { xs: "flex-start", md: "flex-end" },
                      }}
                    >
                      {eventos.event.experience === "presencial" &&
                        eventos.event.ubicacion !== "" &&
                        eventos.event.ubicacion !== null && (
                          <iframe
                            className="ubi frameDisenio"
                            title="presencial"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAaOS-wzdp9p1lzw1LGqcxbOXAG60UE124&q=${eventos.event.ubicacion}`}
                          ></iframe>
                        )}

                      {eventos.event.experience === "hibrido" && (
                        <div className="map_information">
                          {Registrado === true && (
                            <p className="fechaEvent">{eventos.event.stream_url}</p>
                          )}
                          <iframe
                            className="ubi frameDisenio"
                            title="hibrido"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAaOS-wzdp9p1lzw1LGqcxbOXAG60UE124&q=${eventos.event.ubicacion}`}
                          ></iframe>
                        </div>
                      )}
                    </Grid>
                  )}
                </>
              );
            })}
          </>
        ))}
      </Grid>
    </Box>
  );
}

export { EventoDatos };
